import {
  updateUserInfo
} from "./chunk-OT6P6L6K.mjs";

// src/hooks/wbk/auth/profile.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useUpdateProfile = ({ lang }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateUserInfo,
    onSuccess: (user) => {
      queryClient.setQueryData(["user", { lang }], user);
    }
  });
};

export {
  useUpdateProfile
};
//# sourceMappingURL=chunk-JHUYVGJI.mjs.map